<template>
    <module-card :nextFunction="unlockResources">
        <p>
            <strong>Taking medicines in an emergency situation after a potential exposure to HIV (like if a condom broke during sex) is called PEP or Post-Exposure Prophylaxis.</strong> But PEP must be started no more than 72 hours (3 days)
            after a potential exposure and every hour counts to prevent infection. It’s not a substitute for regular condom use or other prevention methods (like PrEP). People who are prescribed PEP take it once or twice daily for 28 days.
            You may be able to get PEP from your doctor or from a doctor in an emergency room.
        </p>
        <p>To find out more about PEP go to: <external-link href="https://www.cdc.gov/hiv/risk/pep/index.html" target="_blank">https://www.cdc.gov/hiv/risk/pep/index.html</external-link></p>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { forEach } from 'lodash';

    export default {
        computed: {
            resources: sync('resources')
        },
        methods: {
            unlockResources() {
                // unlock alcohol and marijuana resources
                forEach(this.resources, (o) => {
                    if (o.category === 'HIV' && o.topic === 'About PEP') {
                        o.unlocked = true;
                    }
                });
            }
        }
    };
</script>
